import { Currency } from "@wingspanhq/utils/dist/currency/currencies";
import { formatMoney } from "@wingspanhq/utils/dist/formatMoney";

export const formatReportMoney = (
  value?: number,
  currency: Currency | `${Currency}` = Currency.USD
) => {
  return typeof value === "number" ? formatMoney(value, currency) : undefined;
};
